import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";

import { MaalerAflaesningFormBuilder } from "../maaler-aflaesning/maaler-aflaesning-form-builder";
import { InstallationMaalerAflaesningMedMaalerType } from "./model/installation-maaler-aflaesning.model";

export class InstallationMaalerAflaesningFormBuilder {
    public static maalerAflaesningToFormGroup(
        maalerAflaesning: InstallationMaalerAflaesningMedMaalerType,
        visTidligereAflaesning: boolean
    ): UntypedFormGroup {
        const aflaesning = MaalerAflaesningFormBuilder.maalerAflaesningToFormGroup(
            maalerAflaesning.aflaesning,
            maalerAflaesning.maalerType,
            visTidligereAflaesning
        );

        const idag = new Date();
        const result = new UntypedFormGroup({
            ejendomNr: new UntypedFormControl(maalerAflaesning.ejendomNr),
            installationNr: new UntypedFormControl(maalerAflaesning.installationNr),
            aktivNr: new UntypedFormControl(maalerAflaesning.aktivNr),
            dato: new UntypedFormControl(idag, Validators.required),
            aflaesning
        });
        return result;
    }

    public static formGroupToMaalerAflaesning(formGroup: UntypedFormGroup): InstallationMaalerAflaesningMedMaalerType {
        const result: InstallationMaalerAflaesningMedMaalerType = {
            ejendomNr: formGroup.get("ejendomNr").value,
            installationNr: formGroup.get("installationNr").value,
            aktivNr: formGroup.get("aktivNr").value,
            dato: formGroup.get("dato").value,
            aflaesning: MaalerAflaesningFormBuilder.formGroupToMaalerAflaesning(formGroup.get("aflaesning") as UntypedFormGroup),
            maalerType: null
        };
        return result;
    }
}
